import { useContext, useEffect, useState } from "react";
import MainLayout from "../Container/Layout/MainLayout";
// context
import { Context } from "../Context/Context";
// style
import styles from "../Styles/Cart.module.css";
// component
import { ErrorMessage, Field, Form, Formik } from "formik";
import moment from "moment-jalaali";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Notfound from "../Components/Common/Notfound";
import {
  Profile,
  SERVER_URL,
  createOrder,
  discount,
  getAddresses,
  getCompany,
  getServiceList,
  postPrice,
  sysAdminAddress,
  sysAdminData,
  getPaymentType,
  getPaymentCartPageURL,
} from "../Services/ContectService";

const Cart = () => {
  const {
    json,
    user,
    cart,
    setCart,
    loading,
    setLoading,
    numberconvert,
    provinceList,
  } = useContext(Context);
  const content = json?.Cart;
  const contentCartItem = content.cartItem;
  const contentCartInfo = content.cartInfo;

  let navigate = useNavigate();

  // values: l -> local , p -> post
  const [delivery, setDelivery] = useState("l");
  const [cartData, setCartData] = useState([]);
  const [weight, setweight] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [allPrice, setAllPrice] = useState(0);
  const [discountPrice, setDiscountPrice] = useState(0);
  const [discountCode, setDiscountCode] = useState("");
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showAddressesModal, setShowAddressesModal] = useState(false);
  // values: p -> person , c -> company
  const [factorNameType, setFactorNameType] = useState("p");
  const [accountInfo, setAccountInfo] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showCompaniesModal, setShowCompaniesModal] = useState(false);

  const [paymentType, setPaymentType] = useState("p");
  const [transferPrice, setTransferPrice] = useState(0);
  const [transferLoading, setTransferLoading] = useState(false);
  const [paymentData, setPaymentData] = useState({ data: [] });
  const [discountAmount, setDiscountAmount] = useState(0)
  const [paymentAmount, setPaymentAmount] = useState(0)

  const serviceListHandeler = async () => {
    setLoading(true);
    try {
      const { status, data } = await getServiceList(user);
      if (status === 200) {
        cartDataHandler(data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
      setLoading(false);
    }
  };

  const [sysData, setSysData] = useState(null);
  const getSysAdminDataHandler = async () => {
    setLoading(true);
    try {
      const { status, data } = await sysAdminData(user);
      if (status === 200) {
        setSysData(data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const [sysAddress, setSysAddress] = useState(null);
  const getSysAdminAddressHandler = async () => {
    setLoading(true);
    try {
      const { status, data } = await sysAdminAddress(user);
      if (status === 200) {
        setSysAddress(data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const cartDataHandler = (data) => {
    setLoading(true);
    if (data) {
      let total = 0;
      let weightNum = 0;
      let newCartData = cartData;
      for (let cartCode of cart) {
        let find = data.find((item) => item.code == cartCode);
        if (find) {
          // weightNum = weightNum + (find.weight * find.quantity);
          weightNum = weightNum + find.weight;
          total = total + Number(find.total_price);
          newCartData.push(find);
        }
      }
      setCartData(newCartData);
      setTotalPrice(total);
      // setAllPrice(total);
      setweight(weightNum.toFixed(3));
    }
    setLoading(false);
  };

  const cartDeletHandeler = (code) => {
    if (cart.find((item) => item === code)) {
      let filterCart = cart.filter((item) => item !== code);
      let filterData = cartData.filter((item) => item.code !== code);
      setCart(filterCart);
      window.localStorage.setItem("cart", filterCart);
      let find = cartData.find((item) => item.code === code);
      setCartData(filterData);
      setTotalPrice(totalPrice - find.total_price);
      // setAllPrice((prevAllPrice) => {
      //   let newValue = prevAllPrice - find.total_price;
      //   if (newValue < 0) {
      //     return 0;
      //   }
      //   return newValue;
      // });
      // setweight((weight - (find.weight * find.quantity)).toFixed(3));
      setweight((weight - find.weight).toFixed(3));
      toast.success(json.toast.cart_4);
    } else {
      toast.error(json.toast.cart_3);
    }
  };

  const discountHandeler = async (values) => {
    setLoading(true);
    const newObject = {
      code: values.code,
      total_price: totalPrice,
    };
    try {
      const { status, data } = await discount(user, newObject);
      if (status === 200) {
        toast.success(json.toast.cart_5);
        // setAllPrice(data.discounted_price + transferPrice);
        // setDiscountPrice(data.coupon_amount);
        setDiscountCode(values.code);
      }
        
    } catch (error) {
      if (error?.response?.status === 400) {
        toast.error(json.toast.cart_6);
      } else {
        toast.error(json.toast.err_1);
      }
    } finally {
      setLoading(false);
    }
  };

  const deleteDiscountCodeHandler = () => {
    // setAllPrice(totalPrice + transferPrice);
    setDiscountPrice(0);
    setDiscountCode("");
  };

  const getAllAddressesHandeler = async () => {
    setLoading(true);
    try {
      const { status, data } = await getAddresses(user);
      if (status === 200) {
        const notDeletedData = data.filter((item) => !item.is_deleted);
        setAddresses(notDeletedData);
        setSelectedAddress(
          notDeletedData.find((item) => item.default_address) ||
            notDeletedData[0] ||
            null
        );
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    }
  };

  const getAccountInfoHandeler = async () => {
    setLoading(true);
    try {
      const { status, data } = await Profile(user);
      if (status === 200) {
        setAccountInfo(data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    }
  };

  const getAllCompaniesHandeler = async () => {
    setLoading(true);
    try {
      const { status, data } = await getCompany(user);
      if (status === 200) {
        const notDeletedData = data.filter((item) => !item.is_deleted);
        setCompanies(notDeletedData);
        setSelectedCompany(
          notDeletedData.find((item) => item.default_company) ||
            notDeletedData[0] ||
            null
        );
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    }
  };

  const createOrderHandeler = async () => {
    if (cart.length === 0) {
      return toast.error("سبد خرید خالی است");
    }
    if (delivery === "p" && !selectedAddress) {
      return toast.error("لطفاً یک آدرس انتخاب کنید");
    }
    if (factorNameType === "c" && !selectedCompany) {
      return toast.error("لطفاً یک شرکت انتخاب کنید");
    }
    if (!paymentType) {
      return toast.error("لطفاً نحوه پرداخت را انتخاب کنید.");
    }
    if (transferLoading) {
      return toast.error("در حال محاسبه هزینه ارسال هستیم، لطفاً صبر کنید.");
    }

    let cartItem = [];
    setLoading(true);

    for (let i = 0; i < cart.length; i++) {
      cartItem.push({ code: cart[i] });
    }
    const newObject = {
      service_code: cartItem,
      delivery_type: delivery,
      discount_code: discountCode,
      address: selectedAddress?.id,
      receiver: factorNameType === "p" ? null : selectedCompany?.id,
      payment_type: paymentType,
      transfer_price: transferPrice,
    };

    try {
      // const { status, data } = await createOrder(newObject, user);
      const { status } = await createOrder(newObject, user);
      if (status === 200) {
        toast.success("سفارش شما ثبت شد");
        setCart([]);
        window.localStorage.removeItem("cart");
        return navigate("/Order");
        // goToPaymentPageHandler(data);
      } else {
        toast.error(json.toast.err_1);
        setLoading(false);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
      setLoading(false);
    }
  };
  

  const setPaymentTypeHandeler = async () => {
    // if (cart.length === 0) {
    //   return toast.error("سبد خرید خالی است");
    // }
    if (delivery === "p" && !selectedAddress) {
      return toast.error("لطفاً یک آدرس انتخاب کنید");
    }
    if (factorNameType === "c" && !selectedCompany) {
      return toast.error("لطفاً یک شرکت انتخاب کنید");
    }
    if (!paymentType) {
      return toast.error("لطفاً نحوه پرداخت را انتخاب کنید.");
    }
    if (transferLoading) {
      return toast.error("در حال محاسبه هزینه ارسال هستیم، لطفاً صبر کنید.");
    }

    let cartItem = [];
    setLoading(true);

    for (let i = 0; i < cart.length; i++) {
      cartItem.push({ code: cart[i] });
    }
    const newObject = {
      discount_code: discountCode,
      payment_type: paymentType,
      service_code: cartItem,
      transfer_price: transferPrice,
    };

    try {
      const { status, data } = await getPaymentType(newObject, user);
      if (status === 200) {
        setPaymentData(data);
        setDiscountAmount(data.discount)
        setPaymentAmount(data.all_price)

        // if (paymentType === "p") {
        //   setAllPrice(data.data[0].amount)
        // }
        // else if (paymentType === "t") {
        //   setAllPrice(data.data[0].amount + data.data[1].amount)
        // }

        setLoading(false);
        // goToPaymentPageHandler(data);
      } else {
        toast.error(json.toast.err_1);
        setLoading(false);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
      setLoading(false);
    }
  };

  const paymentTypeHelper = (payment_type) => {
    setPaymentType(payment_type);
  };

  // useEffect(() => {
  //   // This effect will run after paymentType is updated
  //   if (paymentType !== null) {
  //     console.log(paymentType);
  //     setPaymentTypeHandeler();
  //   }
  // }, [paymentType]);

  useEffect(() => {

    setPaymentTypeHandeler();

  }, [transferPrice, cartData, paymentType, discountCode])

  const goToPaymentCartPageHandler = async (
    // installmentId,
    // orderCode,
    // amount,
    user,
    amount
  ) => {
    let cartItem = [];
    setLoading(true);
    for (let i = 0; i < cart.length; i++) {
      cartItem.push({ code: cart[i] });
    }

    const orderData = {
      service_code: cartItem,
      delivery_type: delivery,
      discount_code: discountCode,
      address: selectedAddress?.id,
      receiver: factorNameType === "p" ? null : selectedCompany?.id,
      payment_type: paymentType,
      transfer_price: transferPrice,
      amount: amount
    }

    try { 
      const response = await getPaymentCartPageURL(
        user,
        orderData
      );
      if (response.status === 200) {
        window.location.replace(response.data.url);
        window.localStorage.removeItem("cart");
      } else {
        toast.error(json.toast.err_1);
        setLoading(false);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
      setLoading(false);
    }
  };

  // const setPaymentTypeHandler = async (value) => {
  //     const result = await swal({
  //         title: "تایید عملیات",
  //         icon: "info",
  //         text: "پس از انتخاب این گزینه، سفارش شما ثبت خواهد شد.\nآیا می‌خواهید این گزینه را انتخاب کنید؟",
  //         buttons: ["لغو", "تایید"],
  //         dangerMode: true
  //     });
  //     if (result) setPaymentType(value);
  // }

  const getTransferPriceHandler = async () => {
    const data = {
      total_mass: weight,
      total_price: totalPrice,
      to_state: selectedAddress.province,
    };
    setTransferLoading(true);
    try {
      const response = await postPrice(data, user);
      if (response.status === 200) {
        // setAllPrice(
        //   (prevValue) =>
        //     prevValue - transferPrice + Number(response.data.sending_cost)
        // );
        setTransferPrice(Number(response.data.sending_cost));
      }
    } catch (error) {
      setDelivery("l");
      toast.error("در محاسبه‌ی هزینه ارسال مشکلی رخ داده است!");
    } finally {
      setTransferLoading(false);
    }
  };

  useEffect(() => {
    getSysAdminDataHandler();
    getSysAdminAddressHandler();
    getAllAddressesHandeler();
    getAccountInfoHandeler();
    getAllCompaniesHandeler();
    serviceListHandeler();
  }, []);

  // useEffect(() => {
  //     if (paymentType && !transferLoading) {
  //         createOrderHandeler();
  //     }
  // }, [paymentType, transferLoading]);

  useEffect(() => {
    if (delivery === "p") {
      if (selectedAddress && totalPrice > 0) {
        getTransferPriceHandler();
      } else {
        // setAllPrice(0);
        setTransferPrice(0);
      }
    } else if (delivery === "l" && transferPrice > 0) {
      // setAllPrice((prevValue) => prevValue - transferPrice);
      setTransferPrice(0);
    }
  }, [selectedAddress, totalPrice, delivery]);

  return (
    <MainLayout>
      <div className={styles.cartSection}>
        <div className="flex justify-between w-full">
          <h3 className="fs-5">{content.mainTitle}</h3>
          <button
            onClick={() => navigate(-1)}
            className="main-btn main-btn-fill"
          >
            <span className="hidden lg:block">{content.backBtn}</span>
            <svg
              width="32"
              height="30"
              viewBox="0 0 32 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28.4992 15.0001C28.4992 15.3524 28.3412 15.6903 28.0599 15.9395C27.7786 16.1886 27.3971 16.3286 26.9992 16.3286H8.62423L15.0642 22.0315C15.346 22.2811 15.5043 22.6196 15.5043 22.9726C15.5043 23.3256 15.346 23.6641 15.0642 23.9137C14.7824 24.1632 14.4002 24.3035 14.0017 24.3035C13.6032 24.3035 13.221 24.1632 12.9392 23.9137L3.93923 15.9422C3.79939 15.8188 3.68843 15.6721 3.61273 15.5106C3.53702 15.3492 3.49805 15.176 3.49805 15.0012C3.49805 14.8263 3.53702 14.6532 3.61273 14.4917C3.68843 14.3302 3.79939 14.1835 3.93923 14.0601L12.9392 6.08866C13.0788 5.96507 13.2444 5.86704 13.4267 5.80016C13.609 5.73328 13.8044 5.69885 14.0017 5.69885C14.1991 5.69885 14.3944 5.73328 14.5768 5.80016C14.7591 5.86704 14.9247 5.96507 15.0642 6.08866C15.2038 6.21224 15.3144 6.35895 15.39 6.52042C15.4655 6.68189 15.5043 6.85496 15.5043 7.02973C15.5043 7.2045 15.4655 7.37756 15.39 7.53903C15.3144 7.7005 15.2038 7.84722 15.0642 7.9708L8.62423 13.6715H26.9992C27.3971 13.6715 27.7786 13.8115 28.0599 14.0606C28.3412 14.3098 28.4992 14.6477 28.4992 15.0001Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
        <div className="flex flex-wrap justify-between w-full">
          <div className={styles.cartItem}>
            <div className={styles.cartHeader}>
              {contentCartItem.headerTextItem}
            </div>
            {loading ? (
              <div className="flex justify-center px-2 py-5 h3">
                لطفاً صبر کنید...
              </div>
            ) : cartData.length > 0 ? (
              cartData.map((item, index) => (
                <div className={styles.cartSection2} key={`cartItem_${index}`}>
                  <div className="w-full flex flex-col md:flex-row justify-between items-stretch flex-wrap gap-4">
                    <div className="flex flex-col justify-around">
                      <p>
                        {contentCartItem.cartItemInfo.text1}&nbsp;
                        <span>ماشینکاری CNC</span>
                      </p>
                      <p>
                        {contentCartItem.cartItemInfo.text2}&nbsp;
                        <span>
                          {/* {item.preparation_date
                            ? moment(item.preparation_date).format(
                                "jYYYY/jMM/jDD"
                              )
                            : ""} */}
                          {item.preparation_time
                            ? moment()
                                .add(item.preparation_time, "days")
                                .format("jYYYY/jMM/jDD")
                            : ""}
                        </span>
                      </p>
                      <p>
                        {contentCartItem.cartItemInfo.text3}&nbsp;
                        <span>{item.quantity}</span>
                      </p>
                      <p>
                        {contentCartItem.cartItemInfo.text4}&nbsp;
                        <span>
                          {Number.isNaN(Number(item.unit_price))
                            ? item.unit_price
                            : Number(item.unit_price).toLocaleString()}{" "}
                          تومان
                        </span>
                      </p>
                      <p>
                        {contentCartItem.cartItemInfo.text5}&nbsp;
                        <span className="text-[#FF0000]">
                          {Number.isNaN(Number(item.total_price))
                            ? item.total_price
                            : Number(item.total_price).toLocaleString()}{" "}
                          تومان
                        </span>
                      </p>
                    </div>
                    <div className="flex flex-col items-center">
                      <div className={styles.accordion_item_img}>
                        <img
                          src={`${SERVER_URL}/${item.image}`}
                          onError={(e) => {
                            e.target.src = "/imgs/upload/wisercam image.png";
                          }}
                          alt="service pic"
                        />
                      </div>
                      <div className="w-full flex items-center justify-center flex-wrap mt-4 gap-2">
                        <button
                          className={`main-btn main-btn-fill 
                                                    text-black bg-[#D9D9D9] no-color
                                                    ${
                                                      transferLoading
                                                        ? "pointer-events-none"
                                                        : ""
                                                    }`}
                          onClick={() => cartDeletHandeler(item.code)}
                        >
                          {contentCartItem.cartItemInfo.btnRemove}
                          <svg
                            width="35"
                            height="32"
                            viewBox="0 0 35 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M29.1544 6H24.4289V4.5C24.4289 3.57174 24.0416 2.6815 23.3524 2.02513C22.6631 1.36875 21.7282 1 20.7534 1H14.4527C13.4779 1 12.5431 1.36875 11.8538 2.02513C11.1645 2.6815 10.7773 3.57174 10.7773 4.5V6H6.05174C5.63398 6 5.23333 6.15804 4.93792 6.43934C4.64252 6.72064 4.47656 7.10218 4.47656 7.5C4.47656 7.89782 4.64252 8.27936 4.93792 8.56066C5.23333 8.84196 5.63398 9 6.05174 9H6.5768V26C6.5768 26.663 6.8534 27.2989 7.34574 27.7678C7.83808 28.2366 8.50583 28.5 9.20211 28.5H26.004C26.7003 28.5 27.3681 28.2366 27.8604 27.7678C28.3527 27.2989 28.6293 26.663 28.6293 26V9H29.1544C29.5722 9 29.9728 8.84196 30.2682 8.56066C30.5636 8.27936 30.7296 7.89782 30.7296 7.5C30.7296 7.10218 30.5636 6.72064 30.2682 6.43934C29.9728 6.15804 29.5722 6 29.1544 6ZM13.9276 4.5C13.9276 4.36739 13.983 4.24021 14.0814 4.14645C14.1799 4.05268 14.3135 4 14.4527 4H20.7534C20.8927 4 21.0262 4.05268 21.1247 4.14645C21.2232 4.24021 21.2785 4.36739 21.2785 4.5V6H13.9276V4.5ZM25.479 25.5H9.72717V9H25.479V25.5ZM16.0279 13V21C16.0279 21.3978 15.8619 21.7794 15.5665 22.0607C15.2711 22.342 14.8705 22.5 14.4527 22.5C14.0349 22.5 13.6343 22.342 13.3389 22.0607C13.0435 21.7794 12.8775 21.3978 12.8775 21V13C12.8775 12.6022 13.0435 12.2206 13.3389 11.9393C13.6343 11.658 14.0349 11.5 14.4527 11.5C14.8705 11.5 15.2711 11.658 15.5665 11.9393C15.8619 12.2206 16.0279 12.6022 16.0279 13ZM22.3286 13V21C22.3286 21.3978 22.1627 21.7794 21.8673 22.0607C21.5719 22.342 21.1712 22.5 20.7534 22.5C20.3357 22.5 19.935 22.342 19.6396 22.0607C19.3442 21.7794 19.1783 21.3978 19.1783 21V13C19.1783 12.6022 19.3442 12.2206 19.6396 11.9393C19.935 11.658 20.3357 11.5 20.7534 11.5C21.1712 11.5 21.5719 11.658 21.8673 11.9393C22.1627 12.2206 22.3286 12.6022 22.3286 13Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                        <Link
                          to={`/DetailOrder/${item.code}`}
                          className="main-btn main-btn-fill"
                        >
                          {contentCartItem.cartItemInfo.btnDetails}
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.4996 12.7575V5C8.4996 4.60218 8.34157 4.22064 8.06026 3.93934C7.77896 3.65804 7.39743 3.5 6.9996 3.5C6.60178 3.5 6.22025 3.65804 5.93894 3.93934C5.65764 4.22064 5.4996 4.60218 5.4996 5V12.7575C4.62234 13.0677 3.86283 13.6423 3.32564 14.4021C2.78845 15.1619 2.5 16.0695 2.5 17C2.5 17.9305 2.78845 18.8381 3.32564 19.5979C3.86283 20.3577 4.62234 20.9323 5.4996 21.2425V27C5.4996 27.3978 5.65764 27.7794 5.93894 28.0607C6.22025 28.342 6.60178 28.5 6.9996 28.5C7.39743 28.5 7.77896 28.342 8.06026 28.0607C8.34157 27.7794 8.4996 27.3978 8.4996 27V21.2425C9.37686 20.9323 10.1364 20.3577 10.6736 19.5979C11.2108 18.8381 11.4992 17.9305 11.4992 17C11.4992 16.0695 11.2108 15.1619 10.6736 14.4021C10.1364 13.6423 9.37686 13.0677 8.4996 12.7575ZM6.9996 18.5C6.70293 18.5 6.41292 18.412 6.16625 18.2472C5.91957 18.0824 5.72731 17.8481 5.61378 17.574C5.50025 17.2999 5.47055 16.9983 5.52842 16.7074C5.5863 16.4164 5.72916 16.1491 5.93894 15.9393C6.14872 15.7296 6.41599 15.5867 6.70697 15.5288C6.99794 15.4709 7.29954 15.5006 7.57363 15.6142C7.84772 15.7277 8.08198 15.92 8.24681 16.1666C8.41163 16.4133 8.4996 16.7033 8.4996 17C8.4996 17.3978 8.34157 17.7794 8.06026 18.0607C7.77896 18.342 7.39743 18.5 6.9996 18.5ZM20.4996 11C20.4983 10.0698 20.2093 9.16268 19.6722 8.40314C19.1351 7.6436 18.3762 7.06879 17.4996 6.7575V5C17.4996 4.60218 17.3416 4.22064 17.0603 3.93934C16.779 3.65804 16.3974 3.5 15.9996 3.5C15.6018 3.5 15.2202 3.65804 14.9389 3.93934C14.6576 4.22064 14.4996 4.60218 14.4996 5V6.7575C13.6223 7.06775 12.8628 7.64232 12.3256 8.4021C11.7885 9.16187 11.5 10.0695 11.5 11C11.5 11.9305 11.7885 12.8381 12.3256 13.5979C12.8628 14.3577 13.6223 14.9323 14.4996 15.2425V27C14.4996 27.3978 14.6576 27.7794 14.9389 28.0607C15.2202 28.342 15.6018 28.5 15.9996 28.5C16.3974 28.5 16.779 28.342 17.0603 28.0607C17.3416 27.7794 17.4996 27.3978 17.4996 27V15.2425C18.3762 14.9312 19.1351 14.3564 19.6722 13.5969C20.2093 12.8373 20.4983 11.9302 20.4996 11ZM15.9996 12.5C15.7029 12.5 15.4129 12.412 15.1662 12.2472C14.9196 12.0824 14.7273 11.8481 14.6138 11.574C14.5003 11.2999 14.4705 10.9983 14.5284 10.7074C14.5863 10.4164 14.7292 10.1491 14.9389 9.93934C15.1487 9.72956 15.416 9.5867 15.707 9.52882C15.9979 9.47094 16.2995 9.50065 16.5736 9.61418C16.8477 9.72771 17.082 9.91997 17.2468 10.1666C17.4116 10.4133 17.4996 10.7033 17.4996 11C17.4996 11.3978 17.3416 11.7794 17.0603 12.0607C16.779 12.342 16.3974 12.5 15.9996 12.5ZM29.4996 21C29.4983 20.0698 29.2093 19.1627 28.6722 18.4031C28.1351 17.6436 27.3762 17.0688 26.4996 16.7575V5C26.4996 4.60218 26.3416 4.22064 26.0603 3.93934C25.779 3.65804 25.3974 3.5 24.9996 3.5C24.6018 3.5 24.2202 3.65804 23.9389 3.93934C23.6576 4.22064 23.4996 4.60218 23.4996 5V16.7575C22.6223 17.0677 21.8628 17.6423 21.3256 18.4021C20.7885 19.1619 20.5 20.0695 20.5 21C20.5 21.9305 20.7885 22.8381 21.3256 23.5979C21.8628 24.3577 22.6223 24.9323 23.4996 25.2425V27C23.4996 27.3978 23.6576 27.7794 23.9389 28.0607C24.2202 28.342 24.6018 28.5 24.9996 28.5C25.3974 28.5 25.779 28.342 26.0603 28.0607C26.3416 27.7794 26.4996 27.3978 26.4996 27V25.2425C27.3762 24.9312 28.1351 24.3564 28.6722 23.5969C29.2093 22.8373 29.4983 21.9302 29.4996 21ZM24.9996 22.5C24.7029 22.5 24.4129 22.412 24.1662 22.2472C23.9196 22.0824 23.7273 21.8481 23.6138 21.574C23.5003 21.2999 23.4705 20.9983 23.5284 20.7074C23.5863 20.4164 23.7292 20.1491 23.9389 19.9393C24.1487 19.7296 24.416 19.5867 24.707 19.5288C24.9979 19.4709 25.2995 19.5007 25.5736 19.6142C25.8477 19.7277 26.082 19.92 26.2468 20.1666C26.4116 20.4133 26.4996 20.7033 26.4996 21C26.4996 21.3978 26.3416 21.7794 26.0603 22.0607C25.779 22.342 25.3974 22.5 24.9996 22.5Z"
                              fill="white"
                            />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <Notfound />
            )}

            {/* Delivery */}
            <div className={`${styles.cartHeader} font-bold`}>
              <span>{contentCartItem.headerDelivery.text1}</span>
              <span>
                {contentCartItem.headerDelivery.text2}&nbsp;
                <span>{weight} کیلوگرم</span>
              </span>
            </div>
            <div className={styles.cartSection2}>
              <div className="flex flex-col w-full gap-3">
                <div className="flex gap-3">
                  <input
                    type="radio"
                    name="deliveryName"
                    id="delivery-1"
                    onChange={() => setDelivery("l")}
                    checked={delivery === "l" ? true : false}
                    className={`${
                      transferLoading ? "pointer-events-none" : ""
                    }`}
                  />
                  <label htmlFor="delivery-1">
                    {contentCartItem.delivery1.label}
                  </label>
                </div>
                {delivery === "l" && (
                  <div>
                    <div className="flex gap-2 color-info fs-6 mb-3">
                      <svg
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.6563 7.875C10.6563 7.57833 10.7442 7.28832 10.909 7.04164C11.0739 6.79497 11.3081 6.60271 11.5822 6.48918C11.8563 6.37565 12.1579 6.34594 12.4489 6.40382C12.7399 6.4617 13.0071 6.60456 13.2169 6.81434C13.4267 7.02412 13.5696 7.29139 13.6274 7.58236C13.6853 7.87334 13.6556 8.17494 13.5421 8.44902C13.4285 8.72311 13.2363 8.95738 12.9896 9.1222C12.7429 9.28703 12.4529 9.375 12.1563 9.375C11.7584 9.375 11.3769 9.21696 11.0956 8.93566C10.8143 8.65436 10.6563 8.27282 10.6563 7.875ZM22.6563 12C22.6563 14.0025 22.0624 15.9601 20.9499 17.6251C19.8373 19.2902 18.256 20.5879 16.4059 21.3543C14.5558 22.1206 12.52 22.3211 10.556 21.9305C8.59191 21.5398 6.78781 20.5755 5.3718 19.1595C3.95579 17.7435 2.99148 15.9393 2.6008 13.9753C2.21013 12.0112 2.41064 9.97543 3.17697 8.12533C3.94331 6.27523 5.24106 4.69392 6.90611 3.58137C8.57115 2.46882 10.5287 1.875 12.5313 1.875C15.2157 1.87798 17.7893 2.94567 19.6874 4.84383C21.5856 6.74199 22.6533 9.3156 22.6563 12ZM20.4063 12C20.4063 10.4425 19.9444 8.91992 19.0791 7.62488C18.2138 6.32985 16.9839 5.32049 15.5449 4.72445C14.1059 4.12841 12.5225 3.97246 10.9949 4.27632C9.46732 4.58017 8.06413 5.3302 6.96279 6.43153C5.86145 7.53287 5.11143 8.93606 4.80757 10.4637C4.50371 11.9913 4.65966 13.5747 5.2557 15.0136C5.85174 16.4526 6.8611 17.6825 8.15614 18.5478C9.45118 19.4131 10.9737 19.875 12.5313 19.875C14.6191 19.8728 16.6209 19.0424 18.0973 17.566C19.5736 16.0896 20.404 14.0879 20.4063 12ZM13.6563 15.4387V12.375C13.6563 11.8777 13.4587 11.4008 13.1071 11.0492C12.7554 10.6975 12.2785 10.5 11.7813 10.5C11.5156 10.4996 11.2583 10.5932 11.0551 10.7643C10.8518 10.9354 10.7157 11.173 10.6708 11.4348C10.6259 11.6967 10.6751 11.966 10.8097 12.195C10.9443 12.4241 11.1556 12.5981 11.4063 12.6863V15.75C11.4063 16.2473 11.6038 16.7242 11.9554 17.0758C12.3071 17.4275 12.784 17.625 13.2813 17.625C13.5469 17.6254 13.8042 17.5318 14.0074 17.3607C14.2107 17.1896 14.3468 16.952 14.3917 16.6902C14.4367 16.4283 14.3874 16.159 14.2528 15.93C14.1182 15.7009 13.9069 15.5269 13.6563 15.4387Z"
                          fill="#367CFF"
                        />
                      </svg>
                      {contentCartItem.delivery1.infoMessage1}
                    </div>
                    <div className={styles.cartAddressInfo}>
                      <div className="flex flex-col gap-2">
                        <div className="font-bold">
                          {" "}
                          {`استان ${
                              provinceList.find(
                                (p) => p.state === sysAddress?.province
                              )?.name
                            }، شهر ${sysAddress?.city}، ${
                              sysAddress?.address
                          }`}
                        </div>
                        <div className="text-[#7F7F7F] font-bold">
                          {sysAddress?.reciever_name}
                        </div>
                        <div className="text-[#7F7F7F] font-bold">
                          شماره تماس: {sysAddress?.phone_number}
                        </div>
                      </div>
                      {/* <div className={styles.cartAddressInfoItem}>
                                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M16 7.5C14.9122 7.5 13.8488 7.82257 12.9444 8.42692C12.0399 9.03126 11.3349 9.89025 10.9187 10.8952C10.5024 11.9002 10.3935 13.0061 10.6057 14.073C10.8179 15.1399 11.3417 16.1199 12.1109 16.8891C12.8801 17.6583 13.8601 18.1821 14.927 18.3943C15.9939 18.6065 17.0998 18.4976 18.1048 18.0813C19.1098 17.6651 19.9687 16.9601 20.5731 16.0556C21.1774 15.1512 21.5 14.0878 21.5 13C21.4983 11.5418 20.9184 10.1438 19.8873 9.11274C18.8562 8.08165 17.4582 7.50165 16 7.5ZM16 15.5C15.5055 15.5 15.0222 15.3534 14.6111 15.0787C14.2 14.804 13.8795 14.4135 13.6903 13.9567C13.5011 13.4999 13.4516 12.9972 13.548 12.5123C13.6445 12.0273 13.8826 11.5819 14.2322 11.2322C14.5819 10.8826 15.0273 10.6445 15.5123 10.548C15.9972 10.4516 16.4999 10.5011 16.9567 10.6903C17.4135 10.8795 17.804 11.2 18.0787 11.6111C18.3534 12.0222 18.5 12.5055 18.5 13C18.5 13.663 18.2366 14.2989 17.7678 14.7678C17.2989 15.2366 16.663 15.5 16 15.5ZM16 1.5C12.951 1.50331 10.0279 2.71597 7.87193 4.87193C5.71597 7.02788 4.50331 9.95103 4.5 13C4.5 22.67 14.705 29.925 15.14 30.2288C15.3921 30.4052 15.6923 30.4998 16 30.4998C16.3077 30.4998 16.6079 30.4052 16.86 30.2288C18.7928 28.8043 20.5612 27.1692 22.1325 25.3538C25.6437 21.3213 27.5 17.0462 27.5 13C27.4967 9.95103 26.284 7.02788 24.1281 4.87193C21.9721 2.71597 19.049 1.50331 16 1.5ZM19.9125 23.3388C18.7207 24.7078 17.4115 25.9701 16 27.1112C14.5885 25.9701 13.2793 24.7078 12.0875 23.3388C10 20.9213 7.5 17.1638 7.5 13C7.5 10.7457 8.39553 8.58365 9.98959 6.98959C11.5837 5.39553 13.7457 4.5 16 4.5C18.2543 4.5 20.4163 5.39553 22.0104 6.98959C23.6045 8.58365 24.5 10.7457 24.5 13C24.5 17.1638 22 20.9213 19.9125 23.3388Z" fill="black" />
                                                </svg>
                                                {contentCartItem.delivery1.addressInfo.textItem2}
                                            </div>
                                            <div className={styles.cartAddressInfoItem}>
                                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M21.9981 19.5C20.6586 19.4978 19.3648 19.9871 18.3618 20.875L13.2606 17.6C13.5772 16.5568 13.5772 15.4432 13.2606 14.4L18.3618 11.125C19.3548 11.9976 20.6297 12.4818 21.9516 12.4883C23.2735 12.4948 24.5531 12.0232 25.5546 11.1604C26.5561 10.2976 27.2118 9.10177 27.4009 7.79348C27.5901 6.4852 27.2998 5.15264 26.5837 4.04154C25.8675 2.93044 24.7738 2.11572 23.5042 1.74761C22.2346 1.37949 20.8748 1.48282 19.6754 2.03852C18.476 2.59423 17.5179 3.56484 16.9779 4.77138C16.4378 5.97793 16.3522 7.33904 16.7368 8.60374L11.6343 11.875C10.8409 11.1737 9.86181 10.7165 8.81477 10.5581C7.76774 10.3997 6.69725 10.547 5.73186 10.9822C4.76648 11.4174 3.94725 12.122 3.37257 13.0114C2.79789 13.9009 2.49219 14.9373 2.49219 15.9962C2.49219 17.0552 2.79789 18.0916 3.37257 18.981C3.94725 19.8705 4.76648 20.5751 5.73186 21.0103C6.69725 21.4455 7.76774 21.5928 8.81477 21.4344C9.86181 21.276 10.8409 20.8187 11.6343 20.1175L16.7356 23.4C16.399 24.507 16.4201 25.6919 16.7958 26.7862C17.1716 27.8805 17.8829 28.8284 18.8285 29.4951C19.7741 30.1618 20.9059 30.5133 22.0628 30.4996C23.2198 30.4859 24.3429 30.1077 25.2725 29.4188C26.202 28.7299 26.8907 27.7654 27.2404 26.6625C27.5902 25.5596 27.5832 24.3745 27.2205 23.2759C26.8578 22.1772 26.1578 21.2208 25.2202 20.5429C24.2826 19.865 23.1551 19.5001 21.9981 19.5ZM21.9981 4.49999C22.4925 4.49999 22.9759 4.64661 23.387 4.92131C23.7981 5.19602 24.1186 5.58646 24.3078 6.04328C24.497 6.50009 24.5465 7.00276 24.4501 7.48771C24.3536 7.97266 24.1155 8.41812 23.7659 8.76775C23.4162 9.11738 22.9708 9.35549 22.4858 9.45195C22.0009 9.54841 21.4982 9.4989 21.0414 9.30968C20.5846 9.12047 20.1941 8.80003 19.9194 8.38891C19.6447 7.97779 19.4981 7.49444 19.4981 6.99999C19.4981 6.33694 19.7615 5.70106 20.2303 5.23222C20.6992 4.76338 21.3351 4.49999 21.9981 4.49999ZM7.99809 18.5C7.50364 18.5 7.02029 18.3534 6.60917 18.0787C6.19804 17.804 5.87761 17.4135 5.68839 16.9567C5.49917 16.4999 5.44967 15.9972 5.54613 15.5123C5.64259 15.0273 5.88069 14.5819 6.23033 14.2322C6.57996 13.8826 7.02541 13.6445 7.51037 13.548C7.99532 13.4516 8.49799 13.5011 8.9548 13.6903C9.41162 13.8795 9.80206 14.1999 10.0768 14.6111C10.3515 15.0222 10.4981 15.5055 10.4981 16C10.4981 16.663 10.2347 17.2989 9.76586 17.7678C9.29702 18.2366 8.66113 18.5 7.99809 18.5ZM21.9981 27.5C21.5036 27.5 21.0203 27.3534 20.6092 27.0787C20.198 26.804 19.8776 26.4135 19.6884 25.9567C19.4992 25.4999 19.4497 24.9972 19.5461 24.5123C19.6426 24.0273 19.8807 23.5819 20.2303 23.2322C20.58 22.8826 21.0254 22.6445 21.5104 22.548C21.9953 22.4516 22.498 22.5011 22.9548 22.6903C23.4116 22.8795 23.8021 23.1999 24.0768 23.6111C24.3515 24.0222 24.4981 24.5055 24.4981 25C24.4981 25.663 24.2347 26.2989 23.7659 26.7678C23.297 27.2366 22.6611 27.5 21.9981 27.5Z" fill="black" />
                                                </svg>
                                                {contentCartItem.delivery1.addressInfo.textItem3}
                                            </div> */}
                    </div>
                  </div>
                )}

                <div className="flex gap-3">
                  <input
                    type="radio"
                    name="deliveryName"
                    id="delivery-2"
                    onChange={() => setDelivery("p")}
                    checked={delivery === "p" ? true : false}
                  />
                  <label htmlFor="delivery-2">
                    {contentCartItem.delivery2.label}
                  </label>
                </div>
                {delivery === "p" && (
                  <>
                    {selectedAddress ? (
                      <div className={styles.cartAddressInfo}>
                        <div className="flex flex-col gap-2">
                          <div className="font-bold">
                            {`استان ${
                              provinceList.find(
                                (p) => p.state === selectedAddress.province
                              )?.name
                            }، شهر ${selectedAddress.city}، ${
                              selectedAddress.physical_address
                            }`}
                          </div>
                          <div className="text-[#7F7F7F] font-bold">
                            گیرنده: {selectedAddress?.reciever_name}
                          </div>
                          <div className="text-[#7F7F7F] font-bold">
                            شماره تماس: {selectedAddress?.phone_number}
                          </div>
                        </div>
                        <div
                          className={`${styles.cartAddressInfoItem} mb-auto`}
                          onClick={() => setShowAddressesModal(true)}
                        >
                          <span>تغییر آدرس</span>
                          <img
                            src="./imgs/edit.svg"
                            className="w-[20px] h-[20px]"
                            alt="edit icon"
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className={`${styles.cartAddressInfoItem} justify-start`}
                        onClick={() => setShowAddressesModal(true)}
                      >
                        <span>تعیین آدرس</span>
                        <img
                          src="./imgs/edit.svg"
                          className="w-[20px] h-[20px]"
                          alt="edit icon"
                        />
                      </div>
                    )}
                    {/* Start addresses modal */}
                    <div
                      className={
                        showAddressesModal
                          ? "modal-sheet active"
                          : "modal-sheet"
                      }
                    >
                      <div className="modal-sheet-content bottomSheet-content">
                        <div className="modal-sheet-body">
                          <div className="flex items-center justify-between mb-6">
                            <div className="font-bold text-2xl">آدرس‌ها:</div>
                            <button
                              onClick={() =>
                                navigate("/account/addresses/create")
                              }
                              className="main-btn main-btn-fill"
                            >
                              افزودن آدرس جدید
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M14 0.5C11.33 0.5 8.71987 1.29176 6.49981 2.77516C4.27974 4.25856 2.54942 6.36697 1.52763 8.83377C0.505849 11.3006 0.238504 14.015 0.759405 16.6337C1.28031 19.2525 2.56606 21.6579 4.45406 23.5459C6.34207 25.434 8.74754 26.7197 11.3663 27.2406C13.985 27.7615 16.6994 27.4942 19.1662 26.4724C21.633 25.4506 23.7414 23.7203 25.2248 21.5002C26.7082 19.2801 27.5 16.67 27.5 14C27.496 10.4208 26.0724 6.98932 23.5416 4.45844C21.0107 1.92756 17.5792 0.50397 14 0.5ZM14 24.5C11.9233 24.5 9.89324 23.8842 8.16652 22.7304C6.4398 21.5767 5.09399 19.9368 4.29927 18.0182C3.50455 16.0996 3.29662 13.9884 3.70176 11.9516C4.10691 9.91475 5.10693 8.04383 6.57538 6.57538C8.04384 5.10693 9.91476 4.1069 11.9516 3.70175C13.9884 3.29661 16.0996 3.50454 18.0182 4.29926C19.9368 5.09399 21.5767 6.4398 22.7304 8.16651C23.8842 9.89323 24.5 11.9233 24.5 14C24.497 16.7839 23.3898 19.4528 21.4213 21.4213C19.4529 23.3898 16.7839 24.497 14 24.5ZM20.5 14C20.5 14.3978 20.342 14.7794 20.0607 15.0607C19.7794 15.342 19.3978 15.5 19 15.5H15.5V19C15.5 19.3978 15.342 19.7794 15.0607 20.0607C14.7794 20.342 14.3978 20.5 14 20.5C13.6022 20.5 13.2206 20.342 12.9393 20.0607C12.658 19.7794 12.5 19.3978 12.5 19V15.5H9.00001C8.60218 15.5 8.22065 15.342 7.93935 15.0607C7.65804 14.7794 7.50001 14.3978 7.50001 14C7.50001 13.6022 7.65804 13.2206 7.93935 12.9393C8.22065 12.658 8.60218 12.5 9.00001 12.5H12.5V9C12.5 8.60218 12.658 8.22064 12.9393 7.93934C13.2206 7.65804 13.6022 7.5 14 7.5C14.3978 7.5 14.7794 7.65804 15.0607 7.93934C15.342 8.22064 15.5 8.60218 15.5 9V12.5H19C19.3978 12.5 19.7794 12.658 20.0607 12.9393C20.342 13.2206 20.5 13.6022 20.5 14Z"
                                  fill="white"
                                />
                              </svg>
                            </button>
                          </div>
                          <div className="flex flex-col gap-4">
                            {addresses.map((item, index) => (
                              <div
                                key={`addressItem_${index}`}
                                className={`${styles.cartAddressInfo} 
                                                                ${
                                                                  selectedAddress?.id ===
                                                                  item.id
                                                                    ? "bg-[#B0C3FF99]"
                                                                    : ""
                                                                }
                                                                ${
                                                                  transferLoading
                                                                    ? "pointer-events-none"
                                                                    : ""
                                                                }`}
                                onClick={() => {
                                  setSelectedAddress(item);
                                  setShowAddressesModal(false);
                                }}
                              >
                                <div className="flex flex-col gap-2">
                                  <div className="font-bold">
                                    {`استان ${
                                      provinceList.find(
                                        (p) => p.state === item.province
                                      )?.name
                                    }، شهر ${item.city}، ${
                                      item.physical_address
                                    }`}
                                  </div>
                                  <div className="text-[#7F7F7F] font-bold">
                                    گیرنده: {item.reciever_name}
                                  </div>
                                  <div className="text-[#7F7F7F] font-bold">
                                    شماره تماس: {item.phone_number}
                                  </div>
                                </div>
                                <div
                                  className={`${styles.cartAddressInfoItem} mb-auto`}
                                  onClick={(ev) => {
                                    ev.stopPropagation();
                                    return navigate(
                                      `/account/address/${item.id}`
                                    );
                                  }}
                                >
                                  <span>ویرایش آدرس</span>
                                  <img
                                    src="./imgs/edit.svg"
                                    className="w-[20px] h-[20px]"
                                    alt="edit icon"
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div
                        className="modal-sheet-back"
                        onClick={() => setShowAddressesModal(false)}
                      ></div>
                    </div>
                    {/* End addresses modal */}
                  </>
                )}
              </div>
            </div>

            {/* Factor name type */}
            <div className={`${styles.cartHeader} font-bold`}>
              <span>صدور فاکتور به نام:</span>
            </div>
            <div className={styles.cartSection2}>
              <div className="flex flex-col w-full gap-3">
                <div className="flex gap-3">
                  <input
                    type="radio"
                    name="factorName"
                    id="factorName-1"
                    onChange={() => setFactorNameType("p")}
                    checked={factorNameType === "p" ? true : false}
                  />
                  <label htmlFor="delivery-1">شخص حقیقی</label>
                </div>
                {factorNameType === "p" && accountInfo && (
                  <div className={styles.cartAddressInfo}>
                    <div className="flex flex-col gap-2">
                      <div className="font-bold">
                        {`${accountInfo.name} ${accountInfo.family}`}
                      </div>
                      <div className="text-[#7F7F7F] font-bold">
                        شماره تماس: {accountInfo.phone_number}
                      </div>
                      <div className="text-[#7F7F7F] font-bold">
                        ایمیل: {accountInfo.email}
                      </div>
                    </div>
                    <div
                      className={`${styles.cartAddressInfoItem} mb-auto`}
                      onClick={() => navigate("/account")}
                    >
                      <span>ویرایش اطلاعات</span>
                      <img
                        src="./imgs/edit.svg"
                        className="w-[20px] h-[20px]"
                        alt="edit icon"
                      />
                    </div>
                  </div>
                )}

                <div className="flex gap-3">
                  <input
                    type="radio"
                    name="factorName"
                    id="factorName-2"
                    onChange={() => setFactorNameType("c")}
                    checked={factorNameType === "c" ? true : false}
                  />
                  <label htmlFor="delivery-2">شخص حقوقی</label>
                </div>
                {factorNameType === "c" && (
                  <>
                    {selectedCompany ? (
                      <div className={styles.cartAddressInfo}>
                        <div className="flex flex-col gap-2">
                          <div className="font-bold">
                            {selectedCompany?.name}
                          </div>
                          <div className="text-[#7F7F7F] font-bold">
                            شناسه ملی: {selectedCompany?.national_id || ""}
                          </div>
                          <div className="text-[#7F7F7F] font-bold">
                            {`استان ${
                              provinceList.find(
                                (p) => p.state === selectedCompany?.province
                              )?.name
                            }، شهر ${selectedCompany?.city}، ${
                              selectedCompany?.registration_address
                            }`}
                          </div>
                        </div>
                        <div
                          className={`${styles.cartAddressInfoItem} mb-auto`}
                          onClick={() => setShowCompaniesModal(true)}
                        >
                          <span>ویرایش اطلاعات</span>
                          <img
                            src="./imgs/edit.svg"
                            className="w-[20px] h-[20px]"
                            alt="edit icon"
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className={`${styles.cartAddressInfoItem} justify-start`}
                        onClick={() => setShowCompaniesModal(true)}
                      >
                        <span>تعیین شرکت</span>
                        <img
                          src="./imgs/edit.svg"
                          className="w-[20px] h-[20px]"
                          alt="edit icon"
                        />
                      </div>
                    )}

                    {/* Start companies modal */}
                    <div
                      className={
                        showCompaniesModal
                          ? "modal-sheet active"
                          : "modal-sheet"
                      }
                    >
                      <div className="modal-sheet-content bottomSheet-content">
                        <div className="modal-sheet-body">
                          <div className="flex items-center justify-between mb-6">
                            <div className="font-bold text-2xl">شرکت‌ها:</div>
                            <button
                              onClick={() =>
                                navigate("/account/legal-information/create")
                              }
                              className="main-btn main-btn-fill"
                            >
                              افزودن شرکت جدید
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M14 0.5C11.33 0.5 8.71987 1.29176 6.49981 2.77516C4.27974 4.25856 2.54942 6.36697 1.52763 8.83377C0.505849 11.3006 0.238504 14.015 0.759405 16.6337C1.28031 19.2525 2.56606 21.6579 4.45406 23.5459C6.34207 25.434 8.74754 26.7197 11.3663 27.2406C13.985 27.7615 16.6994 27.4942 19.1662 26.4724C21.633 25.4506 23.7414 23.7203 25.2248 21.5002C26.7082 19.2801 27.5 16.67 27.5 14C27.496 10.4208 26.0724 6.98932 23.5416 4.45844C21.0107 1.92756 17.5792 0.50397 14 0.5ZM14 24.5C11.9233 24.5 9.89324 23.8842 8.16652 22.7304C6.4398 21.5767 5.09399 19.9368 4.29927 18.0182C3.50455 16.0996 3.29662 13.9884 3.70176 11.9516C4.10691 9.91475 5.10693 8.04383 6.57538 6.57538C8.04384 5.10693 9.91476 4.1069 11.9516 3.70175C13.9884 3.29661 16.0996 3.50454 18.0182 4.29926C19.9368 5.09399 21.5767 6.4398 22.7304 8.16651C23.8842 9.89323 24.5 11.9233 24.5 14C24.497 16.7839 23.3898 19.4528 21.4213 21.4213C19.4529 23.3898 16.7839 24.497 14 24.5ZM20.5 14C20.5 14.3978 20.342 14.7794 20.0607 15.0607C19.7794 15.342 19.3978 15.5 19 15.5H15.5V19C15.5 19.3978 15.342 19.7794 15.0607 20.0607C14.7794 20.342 14.3978 20.5 14 20.5C13.6022 20.5 13.2206 20.342 12.9393 20.0607C12.658 19.7794 12.5 19.3978 12.5 19V15.5H9.00001C8.60218 15.5 8.22065 15.342 7.93935 15.0607C7.65804 14.7794 7.50001 14.3978 7.50001 14C7.50001 13.6022 7.65804 13.2206 7.93935 12.9393C8.22065 12.658 8.60218 12.5 9.00001 12.5H12.5V9C12.5 8.60218 12.658 8.22064 12.9393 7.93934C13.2206 7.65804 13.6022 7.5 14 7.5C14.3978 7.5 14.7794 7.65804 15.0607 7.93934C15.342 8.22064 15.5 8.60218 15.5 9V12.5H19C19.3978 12.5 19.7794 12.658 20.0607 12.9393C20.342 13.2206 20.5 13.6022 20.5 14Z"
                                  fill="white"
                                />
                              </svg>
                            </button>
                          </div>
                          <div className="flex flex-col gap-4">
                            {companies.map((item, index) => (
                              <div
                                key={`addressItem_${index}`}
                                className={`${styles.cartAddressInfo} ${
                                  selectedCompany?.id === item.id
                                    ? "bg-[#B0C3FF99]"
                                    : ""
                                }`}
                                onClick={() => {
                                  setSelectedCompany(item);
                                  setShowCompaniesModal(false);
                                }}
                              >
                                <div className="flex flex-col gap-2">
                                  <div className="font-bold">{item.name}</div>
                                  <div className="text-[#7F7F7F] font-bold">
                                    شناسه ملی: {item.national_id || ""}
                                  </div>
                                  <div className="text-[#7F7F7F] font-bold">
                                    {`استان ${
                                      provinceList.find(
                                        (p) => p.state === item.province
                                      )?.name
                                    }، شهر ${item.city}، ${
                                      item.registration_address
                                    }`}
                                  </div>
                                </div>
                                <div
                                  className={`${styles.cartAddressInfoItem} mb-auto`}
                                  onClick={(ev) => {
                                    ev.stopPropagation();
                                    return navigate(
                                      `/account/legal-information/edit/${item.id}`
                                    );
                                  }}
                                >
                                  <span>ویرایش اطلاعات</span>
                                  <img
                                    src="./imgs/edit.svg"
                                    className="w-[20px] h-[20px]"
                                    alt="edit icon"
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div
                        className="modal-sheet-back"
                        onClick={() => setShowCompaniesModal(false)}
                      ></div>
                    </div>
                    {/* End companies modal */}
                  </>
                )}
              </div>
            </div>

            {/* Payment type */}
            <div className={`${styles.cartHeader} font-bold`}>
              <span>نحوه پرداخت:</span>
            </div>
            <div className={styles.cartSection2}>
              <div className="flex flex-col w-full gap-3">
                <div className="flex gap-3">
                  <input
                    type="radio"
                    disabled={cart.length === 0}
                    name="paymentType"
                    id="paymentTypeRadio-1"
                    onChange={() => paymentTypeHelper("p")}
                    checked={paymentType === "p" ? true : false}
                  />
                  <label htmlFor="delivery-1">
                    به صورت یکجا - پیش پرداخت (تخفیف بیشتر)
                  </label>
                </div>
                {paymentType === "p" && (
                  <div className="flex gap-2 color-info fs-6">
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.6563 7.875C10.6563 7.57833 10.7442 7.28832 10.909 7.04164C11.0739 6.79497 11.3081 6.60271 11.5822 6.48918C11.8563 6.37565 12.1579 6.34594 12.4489 6.40382C12.7399 6.4617 13.0071 6.60456 13.2169 6.81434C13.4267 7.02412 13.5696 7.29139 13.6274 7.58236C13.6853 7.87334 13.6556 8.17494 13.5421 8.44902C13.4285 8.72311 13.2363 8.95738 12.9896 9.1222C12.7429 9.28703 12.4529 9.375 12.1563 9.375C11.7584 9.375 11.3769 9.21696 11.0956 8.93566C10.8143 8.65436 10.6563 8.27282 10.6563 7.875ZM22.6563 12C22.6563 14.0025 22.0624 15.9601 20.9499 17.6251C19.8373 19.2902 18.256 20.5879 16.4059 21.3543C14.5558 22.1206 12.52 22.3211 10.556 21.9305C8.59191 21.5398 6.78781 20.5755 5.3718 19.1595C3.95579 17.7435 2.99148 15.9393 2.6008 13.9753C2.21013 12.0112 2.41064 9.97543 3.17697 8.12533C3.94331 6.27523 5.24106 4.69392 6.90611 3.58137C8.57115 2.46882 10.5287 1.875 12.5313 1.875C15.2157 1.87798 17.7893 2.94567 19.6874 4.84383C21.5856 6.74199 22.6533 9.3156 22.6563 12ZM20.4063 12C20.4063 10.4425 19.9444 8.91992 19.0791 7.62488C18.2138 6.32985 16.9839 5.32049 15.5449 4.72445C14.1059 4.12841 12.5225 3.97246 10.9949 4.27632C9.46732 4.58017 8.06413 5.3302 6.96279 6.43153C5.86145 7.53287 5.11143 8.93606 4.80757 10.4637C4.50371 11.9913 4.65966 13.5747 5.2557 15.0136C5.85174 16.4526 6.8611 17.6825 8.15614 18.5478C9.45118 19.4131 10.9737 19.875 12.5313 19.875C14.6191 19.8728 16.6209 19.0424 18.0973 17.566C19.5736 16.0896 20.404 14.0879 20.4063 12ZM13.6563 15.4387V12.375C13.6563 11.8777 13.4587 11.4008 13.1071 11.0492C12.7554 10.6975 12.2785 10.5 11.7813 10.5C11.5156 10.4996 11.2583 10.5932 11.0551 10.7643C10.8518 10.9354 10.7157 11.173 10.6708 11.4348C10.6259 11.6967 10.6751 11.966 10.8097 12.195C10.9443 12.4241 11.1556 12.5981 11.4063 12.6863V15.75C11.4063 16.2473 11.6038 16.7242 11.9554 17.0758C12.3071 17.4275 12.784 17.625 13.2813 17.625C13.5469 17.6254 13.8042 17.5318 14.0074 17.3607C14.2107 17.1896 14.3468 16.952 14.3917 16.6902C14.4367 16.4283 14.3874 16.159 14.2528 15.93C14.1182 15.7009 13.9069 15.5269 13.6563 15.4387Z"
                        fill="#367CFF"
                      />
                    </svg>
                    در این روش، کل مبلغ در زمان ثبت سفارش پرداخت می‌شود.
                  </div>
                )}
                <div className="flex gap-3">
                  <input
                    type="radio"
                    disabled={cart.length === 0}
                    name="paymentType"
                    id="paymentTypeRadio-1"
                    onChange={() => paymentTypeHelper("t")}
                    checked={paymentType === "t" ? true : false}
                  />
                  <label htmlFor="delivery-1">پرداخت در دو مرحله</label>
                </div>
                {paymentType === "t" && (
                  <div className="flex gap-2 color-info fs-6">
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.6563 7.875C10.6563 7.57833 10.7442 7.28832 10.909 7.04164C11.0739 6.79497 11.3081 6.60271 11.5822 6.48918C11.8563 6.37565 12.1579 6.34594 12.4489 6.40382C12.7399 6.4617 13.0071 6.60456 13.2169 6.81434C13.4267 7.02412 13.5696 7.29139 13.6274 7.58236C13.6853 7.87334 13.6556 8.17494 13.5421 8.44902C13.4285 8.72311 13.2363 8.95738 12.9896 9.1222C12.7429 9.28703 12.4529 9.375 12.1563 9.375C11.7584 9.375 11.3769 9.21696 11.0956 8.93566C10.8143 8.65436 10.6563 8.27282 10.6563 7.875ZM22.6563 12C22.6563 14.0025 22.0624 15.9601 20.9499 17.6251C19.8373 19.2902 18.256 20.5879 16.4059 21.3543C14.5558 22.1206 12.52 22.3211 10.556 21.9305C8.59191 21.5398 6.78781 20.5755 5.3718 19.1595C3.95579 17.7435 2.99148 15.9393 2.6008 13.9753C2.21013 12.0112 2.41064 9.97543 3.17697 8.12533C3.94331 6.27523 5.24106 4.69392 6.90611 3.58137C8.57115 2.46882 10.5287 1.875 12.5313 1.875C15.2157 1.87798 17.7893 2.94567 19.6874 4.84383C21.5856 6.74199 22.6533 9.3156 22.6563 12ZM20.4063 12C20.4063 10.4425 19.9444 8.91992 19.0791 7.62488C18.2138 6.32985 16.9839 5.32049 15.5449 4.72445C14.1059 4.12841 12.5225 3.97246 10.9949 4.27632C9.46732 4.58017 8.06413 5.3302 6.96279 6.43153C5.86145 7.53287 5.11143 8.93606 4.80757 10.4637C4.50371 11.9913 4.65966 13.5747 5.2557 15.0136C5.85174 16.4526 6.8611 17.6825 8.15614 18.5478C9.45118 19.4131 10.9737 19.875 12.5313 19.875C14.6191 19.8728 16.6209 19.0424 18.0973 17.566C19.5736 16.0896 20.404 14.0879 20.4063 12ZM13.6563 15.4387V12.375C13.6563 11.8777 13.4587 11.4008 13.1071 11.0492C12.7554 10.6975 12.2785 10.5 11.7813 10.5C11.5156 10.4996 11.2583 10.5932 11.0551 10.7643C10.8518 10.9354 10.7157 11.173 10.6708 11.4348C10.6259 11.6967 10.6751 11.966 10.8097 12.195C10.9443 12.4241 11.1556 12.5981 11.4063 12.6863V15.75C11.4063 16.2473 11.6038 16.7242 11.9554 17.0758C12.3071 17.4275 12.784 17.625 13.2813 17.625C13.5469 17.6254 13.8042 17.5318 14.0074 17.3607C14.2107 17.1896 14.3468 16.952 14.3917 16.6902C14.4367 16.4283 14.3874 16.159 14.2528 15.93C14.1182 15.7009 13.9069 15.5269 13.6563 15.4387Z"
                        fill="#367CFF"
                      />
                    </svg>
                    در این روش، 50% مبلغ در زمان ثبت سفارش و 50% باقی‌مانده قبل
                    از موعد تحویل پرداخت می‌شود. هر گونه تاخیر در پرداخت فیش‌ها
                    تابع قوانین سایت است. برای مشاهده قوانین کلیک کنید.
                  </div>
                )}
                <div className="flex gap-3">
                  <input
                    type="radio"
                    disabled={cart.length === 0}
                    name="paymentType"
                    id="paymentTypeRadio-2"
                    onChange={() => paymentTypeHelper("c")}
                    checked={paymentType === "c" ? true : false}
                  />
                  <label htmlFor="delivery-2">پرداخت براساس قرارداد</label>
                </div>
                {paymentType === "c" && (
                  <div className="flex gap-2 color-info fs-6">
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.6563 7.875C10.6563 7.57833 10.7442 7.28832 10.909 7.04164C11.0739 6.79497 11.3081 6.60271 11.5822 6.48918C11.8563 6.37565 12.1579 6.34594 12.4489 6.40382C12.7399 6.4617 13.0071 6.60456 13.2169 6.81434C13.4267 7.02412 13.5696 7.29139 13.6274 7.58236C13.6853 7.87334 13.6556 8.17494 13.5421 8.44902C13.4285 8.72311 13.2363 8.95738 12.9896 9.1222C12.7429 9.28703 12.4529 9.375 12.1563 9.375C11.7584 9.375 11.3769 9.21696 11.0956 8.93566C10.8143 8.65436 10.6563 8.27282 10.6563 7.875ZM22.6563 12C22.6563 14.0025 22.0624 15.9601 20.9499 17.6251C19.8373 19.2902 18.256 20.5879 16.4059 21.3543C14.5558 22.1206 12.52 22.3211 10.556 21.9305C8.59191 21.5398 6.78781 20.5755 5.3718 19.1595C3.95579 17.7435 2.99148 15.9393 2.6008 13.9753C2.21013 12.0112 2.41064 9.97543 3.17697 8.12533C3.94331 6.27523 5.24106 4.69392 6.90611 3.58137C8.57115 2.46882 10.5287 1.875 12.5313 1.875C15.2157 1.87798 17.7893 2.94567 19.6874 4.84383C21.5856 6.74199 22.6533 9.3156 22.6563 12ZM20.4063 12C20.4063 10.4425 19.9444 8.91992 19.0791 7.62488C18.2138 6.32985 16.9839 5.32049 15.5449 4.72445C14.1059 4.12841 12.5225 3.97246 10.9949 4.27632C9.46732 4.58017 8.06413 5.3302 6.96279 6.43153C5.86145 7.53287 5.11143 8.93606 4.80757 10.4637C4.50371 11.9913 4.65966 13.5747 5.2557 15.0136C5.85174 16.4526 6.8611 17.6825 8.15614 18.5478C9.45118 19.4131 10.9737 19.875 12.5313 19.875C14.6191 19.8728 16.6209 19.0424 18.0973 17.566C19.5736 16.0896 20.404 14.0879 20.4063 12ZM13.6563 15.4387V12.375C13.6563 11.8777 13.4587 11.4008 13.1071 11.0492C12.7554 10.6975 12.2785 10.5 11.7813 10.5C11.5156 10.4996 11.2583 10.5932 11.0551 10.7643C10.8518 10.9354 10.7157 11.173 10.6708 11.4348C10.6259 11.6967 10.6751 11.966 10.8097 12.195C10.9443 12.4241 11.1556 12.5981 11.4063 12.6863V15.75C11.4063 16.2473 11.6038 16.7242 11.9554 17.0758C12.3071 17.4275 12.784 17.625 13.2813 17.625C13.5469 17.6254 13.8042 17.5318 14.0074 17.3607C14.2107 17.1896 14.3468 16.952 14.3917 16.6902C14.4367 16.4283 14.3874 16.159 14.2528 15.93C14.1182 15.7009 13.9069 15.5269 13.6563 15.4387Z"
                        fill="#367CFF"
                      />
                    </svg>
                    در این روش، نحوه پرداخت‌ها بر اساس مندرجات در قرارداد خواهد
                    بود. هر گونه تاخیر در پرداخت‌ها تابع قوانین سایت و قرارداد
                    است.
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Cart info */}
          <div className={styles.cartInfo}>
            <div className={styles.cartHeader}>
              {contentCartInfo.headerInfo}
            </div>
            <div className={styles.cartSection2}>
              <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                <span>{contentCartInfo.price1}</span>
                <span>
                  {Number.isNaN(Number(totalPrice))
                    ? totalPrice
                    : `${Number(totalPrice).toLocaleString()} تومان`}

                </span>
              </div>
              <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                <span>{contentCartInfo.price2}</span>
                {/* <span>
                  {Number.isNaN(Number(discountPrice))
                    ? discountPrice
                    : `${Number(discountPrice).toLocaleString()} تومان`}
                </span> */}
                <span>
                  {Number.isNaN(Number(discountAmount))
                    ? discountAmount
                    : `${Number(discountAmount).toLocaleString()} تومان`}
                  {/* {`${Number(discountAmount).toLocaleString()} تومان`} */}
                </span>
              </div>
              <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                <span>هزینه ارسال</span>
                <span>
                  {Number.isNaN(Number(transferPrice))
                    ? transferPrice
                    : `${Number(transferPrice).toLocaleString()} تومان`}
                </span>
              </div>
              <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                <span>{contentCartInfo.price3}</span>
                <span>
                  {Number.isNaN(Number(paymentAmount))
                    ? paymentAmount
                    : `${Number(paymentAmount).toLocaleString()} تومان`}
                  {/* {paymentType === "p"
                    ? Number.isNaN(Number(allPrice))
                      ? allPrice - discountAmount
                      : `${Number(allPrice - discountAmount).toLocaleString()} تومان`
                    : Number.isNaN(Number(allPrice))
                      ? allPrice
                      : `${Number(allPrice).toLocaleString()} تومان`
                  } */}
                </span>
              </div>
              <Formik
                initialValues={{
                  code: "",
                }}
                onSubmit={(values) => {
                  if (values.code.trim().length === 0) {
                    toast.error("کد تخفیف نمی‌تواند خالی باشد");
                    return;
                  }
                  if (totalPrice === 0) {
                    toast.error("قیمت کل نمی‌تواند 0 باشد");
                    return;
                  }
                  const data = {
                    ...values,
                    code: values.code.trim(),
                  };
                  discountHandeler(data);
                }}
              >
                {(formik) => {
                  return (
                    <Form className="flex justify-between py-3 gap-3">
                      <div className="flex flex-wrap gap-3">
                        <label htmlFor="code" className="mian-label w-25">
                          {contentCartInfo.discount.textCode}
                        </label>
                        <div className="flex gap-3">
                          <div
                            className="input-frame input-frame-two w-auto"
                            style={{
                              opacity: discountCode ? "0.7" : "1",
                              cursor: discountCode ? "auto" : "pointer",
                            }}
                          >
                            <Field
                              disabled={Boolean(discountCode)}
                              type="text"
                              id="code"
                              name="code"
                            />
                          </div>
                          {discountCode ? (
                            <button
                              type="button"
                              onClick={() => {
                                deleteDiscountCodeHandler();
                                formik.setFieldValue("code", "");
                              }}
                            >
                              <svg
                                width="40px"
                                height="40px"
                                viewBox="0 0 1024 1024"
                                fill="red"
                                className="icon"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M512 897.6c-108 0-209.6-42.4-285.6-118.4-76-76-118.4-177.6-118.4-285.6 0-108 42.4-209.6 118.4-285.6 76-76 177.6-118.4 285.6-118.4 108 0 209.6 42.4 285.6 118.4 157.6 157.6 157.6 413.6 0 571.2-76 76-177.6 118.4-285.6 118.4z m0-760c-95.2 0-184.8 36.8-252 104-67.2 67.2-104 156.8-104 252s36.8 184.8 104 252c67.2 67.2 156.8 104 252 104 95.2 0 184.8-36.8 252-104 139.2-139.2 139.2-364.8 0-504-67.2-67.2-156.8-104-252-104z"
                                  fill=""
                                />
                                <path
                                  d="M707.872 329.392L348.096 689.16l-31.68-31.68 359.776-359.768z"
                                  fill=""
                                />
                                <path
                                  d="M328 340.8l32-31.2 348 348-32 32z"
                                  fill=""
                                />
                              </svg>
                            </button>
                          ) : null}
                          <button
                            type="submit"
                            className="main-btn main-btn-fill"
                          >
                            {contentCartInfo.discount.btn}
                          </button>
                        </div>
                        <ErrorMessage
                          name="code"
                          render={(msg) => (
                            <div className="main-error">{msg}</div>
                          )}
                        />
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
            {
              <div className="">
                {paymentData.data.length === 0 && (
                  <div className={`${styles.cartSection2} gap-2`}>
                    <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                      <p>فیش پرداخت 1</p>
                    </div>
                    <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                      {/*<span>{contentCartInfo.price1}</span>
                      <span>
                        {Number.isNaN(Number(totalPrice))
                          ? totalPrice
                          : `${Number(totalPrice).toLocaleString()} تومان`}
                      </span>*/}
                      <span>تاریخ سر رسید:</span>
                      <p>براساس قرارداد</p>
                    </div>
                    <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                      {/*<span>{contentCartInfo.price2}</span>
                      <span>
                        {Number.isNaN(Number(discountPrice))
                          ? discountPrice
                          : `${Number(discountPrice).toLocaleString()} تومان`}
                      </span>*/}
                      <span>قابل پرداخت:</span>
                      <p>براساس قرارداد</p>
                    </div>

                    <button
                      onClick={createOrderHandeler}
                      className={`main-btn main-btn-fill px-12
                        ${
                          paymentAmount === 0
                            ? "no-color bg-[#D9D9D9] text-[#7F7F7F] pointer-events-none"
                            : ""
                        }`}
                    >
                      {contentCartInfo.btnPayment}
                    </button>
                  </div>
                )}
                {paymentData.data.length === 1 &&
                  paymentData.data.map((item, index) => (
                    <div className={`${styles.cartSection2} gap-2`}>
                      <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                        <p>فیش پرداخت {index + 1}</p>
                      </div>
                      <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                        {/*<span>{contentCartInfo.price1}</span>
                      <span>
                        {Number.isNaN(Number(totalPrice))
                          ? totalPrice
                          : `${Number(totalPrice).toLocaleString()} تومان`}
                      </span>*/}
                        <span>تاریخ سر رسید:</span>
                        <p>
                          &nbsp;
                          {item.pay_date
                            ? moment(item.pay_date).format("jYYYY/jMM/jDD") 
                            : ""}
                        </p>
                      </div>
                      <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                        {/*<span>{contentCartInfo.price2}</span>
                      <span>
                        {Number.isNaN(Number(discountPrice))
                          ? discountPrice
                          : `${Number(discountPrice).toLocaleString()} تومان`}
                      </span>*/}
                        <span>قابل پرداخت:</span>

                        <p>
                          {Number.isNaN(Number(item.amount))
                            ? item.amount
                            : `${Number(item.amount).toLocaleString()} تومان`}
                        </p>
                      </div>

                      <button
                        type="submit"
                        className={`main-btn main-btn-fill px-12
                                                                    ${
                                                                      item.is_paid
                                                                        ? "no-color bg-[#00FF5766] text-black pointer-events-none"
                                                                        : ""
                                                                    }`}
                        onClick={
                          item.is_paid
                            ? () => {}
                            : () =>
                                goToPaymentCartPageHandler(
                                  user,
                                  item.amount
                                )
                        }
                      >
                        {item.is_paid ? "پرداخت شده" : "پرداخت"}
                      </button>
                    </div>
                  ))}
                <div className="flex flex-col gap-2">
                  {paymentData.data.length === 2 &&
                    paymentData.data.map((item, index) => (
                      <div className={`${styles.cartSection2} gap-1`}>
                        <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                          <p>فیش پرداخت {index + 1}</p>
                        </div>
                        <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                          {/*<span>{contentCartInfo.price1}</span>
                      <span>
                        {Number.isNaN(Number(totalPrice))
                          ? totalPrice
                          : `${Number(totalPrice).toLocaleString()} تومان`}
                      </span>*/}
                          <span>تاریخ سر رسید:</span>
                          <p>
                            &nbsp;
                            {item.pay_date
                              ? moment(item.pay_date).format("jYYYY/jMM/jDD") 
                              : ""}
                          </p>
                        </div>
                        <div className="flex justify-between py-3 border-b border-neutral-300 w-full">
                          {/*<span>{contentCartInfo.price2}</span>
                      <span>
                        {Number.isNaN(Number(discountPrice))
                          ? discountPrice
                          : `${Number(discountPrice).toLocaleString()} تومان`}
                      </span>*/}
                          <span>قابل پرداخت:</span>

                          <p>
                            {Number.isNaN(Number(item.amount))
                              ? item.amount
                              : `${Number(item.amount).toLocaleString()} تومان`}
                          </p>
                        </div>

                        <button
                          type="submit"
                          className={`main-btn main-btn-fill px-12
                                                                    ${
                                                                      index > 0
                                                                        ? "no-color bg-[#D9D9D9] text-[#7F7F7F] pointer-events-none"
                                                                        : ""
                                                                    }`}
                          onClick={
                            item.is_paid
                              ? () => {}
                              : () =>
                                  goToPaymentCartPageHandler(
                                    user,
                                    item.amount
                                  )
                          }
                        >
                          {item.is_paid ? "پرداخت شده" : "پرداخت"}
                        </button>
                      </div>
                    ))}
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Cart;
